import { connect } from 'react-redux';
import { Link } from '@beef/ui-kit';
import { getLeavePhoneBlockPhone } from "../../store/blocks/leavePhone/selectors";
import { runLeavePhoneClick } from "../../store/checkAddress/actions";
import { toTelHref } from "../../utils";
var mapStateToProps = function mapStateToProps(state) {
  return {
    children: getLeavePhoneBlockPhone(state),
    extraAttributes: {
      style: {
        color: '#1790ff'
      }
    },
    href: toTelHref(getLeavePhoneBlockPhone(state)),
    isNoUnderline: true
  };
};
var mapDispatchToProps = {
  onClick: runLeavePhoneClick
};
export var LeavePhone = connect(mapStateToProps, mapDispatchToProps)(Link);